import {Error} from 'grpc-web';

import {ErrorHandler, getKnowNative} from '../externals';
import {errorCodesMap} from '../constants/errors';

export function getMsgFromErr(error: Error): string {

  try {//report to stackdriver
    ErrorHandler.report(`Catch error: ${error.code} ${error.message}`);
  } catch {
  }

  switch (error.code) {
    case 2:
      return errorCodesMap.USER_NOT_EXIST;
    case 3:
      return errorCodesMap.INVALID_PARAMS;
    case 5:
      return errorCodesMap.NOT_FOUND;
    case 7:
      return errorCodesMap.PERMISSION_DENIED;
    case 9:
      try {
        const obj = parseMessageToObject(error.message);
        return obj.type.trim();
      } catch {
        return errorCodesMap.UNKNOWN;
      }
    case 13:
      return errorCodesMap.INTERNAL;
    case 14:
      return errorCodesMap.NO_INTERNET;
    case 16:
      //todo: remove side effect
      getKnowNative('expired');

      return errorCodesMap.NOT_AUTHENTICATED;
    default:
      return errorCodesMap.UNKNOWN
  }
}

export function getCommonMsgFromErr(error: Error) {

  try {//report to stackdriver
    ErrorHandler.report(`Catch common error: ${error.code} ${error.message}`);
  } catch {
  }

  switch (error.code) {
    case 2:
      return errorCodesMap.USER_NOT_EXIST;
    case 3:
      return errorCodesMap.INVALID_PARAMS;
    case 5:
      return errorCodesMap.NOT_FOUND;
    case 7:
      return errorCodesMap.PERMISSION_DENIED;
    case 13:
      return errorCodesMap.INTERNAL;
    case 14:
      return errorCodesMap.NO_INTERNET;
    case 16:
      getKnowNative('expired');
      return errorCodesMap.NOT_AUTHENTICATED;
    default:
      return null
  }
}

export type ErrorProperty = {
  type: string,
  subject: string,
  description: string
}

export function parseMessageToObject(message: string) {
  const magicStr = '" '; //we use "_ to correctly split message, then split the remaining " at the beginning to perform a magic parse function
  const splited = message.trim().split(magicStr);

  // @ts-ignore
  const results: ErrorProperty = {};

  splited.forEach((str) => {
    const [property, value] = str.split(':');
    results[property as keyof ErrorProperty] = value.replace(/"/g, '').trim(); //split the remaining
  });

  return results
}

export function getFirebaseErrorMsg(errCode: string) {
  switch (errCode) {
    case 'auth/account-exists-with-different-credential':
      return errorCodesMap.FB_ACCOUNT_EXIST;
    case 'auth/auth-domain-config-required':
      return errorCodesMap.FB_AUTH_DOMAIN;
    case 'auth/operation-not-allowed':
      return errorCodesMap.FB_OPERATION_NOT_ALLOWED;
    case 'auth/operation-not-supported-in-this-environment':
      return errorCodesMap.FB_OPERATION_NOT_SUPPORTED;
    case 'auth/cancelled-popup-request': // this case does not mean error
      return '';
    case 'auth/popup-blocked':
      return errorCodesMap.FB_POPUP_BLOCKED;
    case 'auth/popup-closed-by-user':
      return errorCodesMap.FB_POPUP_CLOSED_BY_USER;
    case 'auth/unauthorized-domain':
      return errorCodesMap.FB_UNAUTHORIZED_DOMAIN;
    default:
      return errorCodesMap.UNKNOWN
  }
}
